import { Chip } from '@mui/material';
import type { VariationRequestStatus } from '../../../api/sitesApi';

interface VariationStatusBadgeProps {
  status: VariationRequestStatus;
}

const statusConfig: Record<
  VariationRequestStatus,
  { label: string; color: 'warning' | 'success' | 'error' }
> = {
  Pending: { label: 'Pending', color: 'warning' },
  Approved: { label: 'Approved', color: 'success' },
  Rejected: { label: 'Rejected', color: 'error' },
};

export function VariationStatusBadge({ status }: VariationStatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
}
